<template>
    <div class="record-requests">
        <div class="header">
            <span class="icon"><common-icon name="timer" size="small"></common-icon></span>
            <h5 class="main-title">{{ $t('modals.patient_profile.profile.record_form.head') }}</h5>
        </div>

        <div>
            <template v-if="patientRecordRequests && patientRecordRequests.length > 0">
                <div v-for="request in patientRecordRequests" :key="request.id" class="request-card">
                    <div class="main">
                        <div class="card-headers">
                            <h3 class="hospital">{{ request.toProviderName }}</h3>
                            <div class="badges">
                                <span :class="['status', request.status.toLowerCase()]">
                                    <common-icon :name="getIcon(request.status)" size="tiny"></common-icon>
                                    {{ request.status }}
                                </span>
                                <span v-if="!request.emailRequest" class="network">
                                    {{ $t('modals.patient_profile.profile.request.record_request.network') }}
                                </span>

                                <span v-if="request.emailRequest" class="email">
                                    {{ $t('modals.patient_profile.profile.request.record_request.emails') }}
                                </span>
                            </div>
                        </div>

                        <div class="actions">
                            <button class="btn detail" @click="OpenModel(request)">
                                <common-icon name="view" size="tiny"></common-icon>
                                {{ $t('modals.patient_profile.profile.record_form.button.title') }}
                            </button>
                            <button v-if="request.download" class="btn download">
                                <common-icon name="download" size="tiny"></common-icon>
                                {{ $t('modals.patient_profile.profile.record_form.button.downloadtitle') }}
                            </button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="card_grid">
                            <p>
                                <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.id') }}</strong>
                                {{ $t('modals.patient_profile.profile.request.record_request.req') }}{{ request.id }}
                            </p>
                            <p>
                                <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.date') }}</strong>
                                {{ dateFormate(request.createdDateTime) }}
                            </p>
                            <p v-if="request.expected">
                                <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.expected') }}</strong>
                                {{ request.expected }}
                            </p>
                        </div>

                        <p>
                            <strong>{{ $t('modals.patient_profile.profile.record_form.record.name') }}</strong>
                            {{ request.recordTypes?.join(', ') }}
                        </p>
                        <p>
                            <strong>{{ $t('modals.patient_profile.profile.record_form.notes.name') }}</strong>

                            {{ request.notes }}
                        </p>
                    </div>
                </div>
            </template>
            <div v-else class="request-card">
                <span>{{ $t('modals.patient_profile.profile.request.no_record_request_found') }}</span>
            </div>
        </div>

        <details-model :request="selectedRequest" :isOpen="isDetailsModelOpen" @close="closeModal()"></details-model>
    </div>
</template>

<script>
    import DetailsModel from 'components/page-elements/patient/DetailsModel'
    import { dateFormate } from '~/helpers'

    export default {
        components: { DetailsModel },

        props: {
            patientRecordRequests: { type: Array, required: true },
        },
        data() {
            return {
                isDetailsModelOpen: false,
                selectedRequest: null,
            }
        },
        methods: {
            dateFormate,
            OpenModel(request) {
                this.selectedRequest = request
                this.isDetailsModelOpen = true
            },
            closeModal() {
                this.selectedRequest = null
                this.isDetailsModelOpen = false
            },
            getIcon(status) {
                const map = {
                    PENDING: 'timer',
                    APPROVED: 'check-circle',
                    REJECTED: 'close',
                    RECEIVED: 'download',
                }
                return map[status?.toUpperCase()] || 'info'
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .record-requests {
        padding: 18px;
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    }
    .header {
        display: flex;
        margin-bottom: 12px;
    }
    .main-title {
        font-size: 14px;
        font-weight: 400;
        color: #030213;
        margin-left: 10px;
    }
    .request-card {
        border: 1px solid #e0e0e0;
        border-radius: 10px;
        padding: 16px;
        margin-bottom: 16px;
        background: #fff;
    }
    .request-card:hover {
        background-color: $color--bg-dropdown;
    }
    .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }
    .card-headers {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .hospital {
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
        color: $color-dark-2;
        margin-right: 12px;
    }
    .badges {
        display: flex;
        gap: 6px;
        align-items: center;
    }
    .status {
        padding: 2px 8px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 4px;
    }
    .status.pending {
        background: #fff3cd;
        color: #8d6d0c;
    }
    .status.received {
        background: #cce5ff;
        color: $color--accent-19;
    }
    .status.approved {
        background: $color--accent-5;
        color: $color--accent-10;
    }
    .status.rejected {
        background: $color--accent-11;
        color: $color--accent-4;
    }
    .network {
        border: 1px solid $color--accent-10;
        color: $color--accent-10;
        font-size: 12px;
        padding: 1px 8px;
        font-weight: 500;
        border-radius: 6px;
    }
    .email {
        color: $color--accent-19;
        padding: 2px 8px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 500;
        border: 1px solid $color--accent-19;
    }
    .actions {
        display: flex;
        gap: 8px;
    }
    .btn {
        border: none;
        border-radius: 6px;
        padding: 6px 12px;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .btn.detail {
        border: 1px solid #eee;
    }
    .btn.download {
        background: #fff;
        color: $color--accent-19;
        border: 1px solid #d1d5db;
    }
    .btn.download:hover {
        color: #030213;
        background: #f0f0f0;
    }
    .card-body {
        margin: 12px 0;
        font-size: 14px;
    }
    .card_grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }
    .card-body p {
        margin: 6px 0;
    }
    .card-body p strong {
        color: $color-dark-2;
        font-size: 14px;
        font-weight: 500;
    }
    @media screen and (max-width: 600px) {
        .card-headers,
        .main {
            display: block !important;
        }
    }
</style>
